// src/config/appConfig.js

// API 基础地址
export const API_BASE_URL = 'https://mxapi.mxydt.com';
// export const API_BASE_URL = 'http://testapi.mxydt.com';

// 接口路径定义 (方便后续扩展非展会接口)
export const API_ROUTES = {
  EXHIBITION_SEARCH: '/Hotel/GetHotelWithExhibition', // 按展会查
  NORMAL_SEARCH: '/Hotel/GetHotelWithDate',           // 非展会查
};

// AES 解密密钥
export const AES_KEY = 'FC891BA8AF997D86';

// 分页设置
export const DEFAULT_PAGE_SIZE = 500;


/**
 * 获取授权 Token
 * 逻辑：URL参数 > LocalStorage > 默认Demo值
 */
export function getAuthToken() {
  const urlParams = new URLSearchParams(window.location.search);
  const urlToken = urlParams.get('token');

  if (urlToken) {
    // 存入本地，方便后续接口使用
    localStorage.setItem('auth_token', urlToken);
    return 'Bearer ' + urlToken; // 注意：根据你们后端规范，可能需要加 'Bearer ' 前缀
  }
  // 2. 尝试从本地存储获取
  const localToken = localStorage.getItem('auth_token');
  if (localToken) return 'Bearer ' + localToken;
}